import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PerformanceResponse } from 'src/app/models/performance-response.model'

@Injectable({
  providedIn: 'root',
})
export class PerformanceService {
  public static readonly peformanceEndpoint = '/performance'

  constructor(private readonly http: HttpClient) {}

  getPerformance(fundId: string): Observable<PerformanceResponse> {
    return this.http.get<PerformanceResponse>(
      `vmf/api/${fundId}`.concat(PerformanceService.peformanceEndpoint),
    )
  }
}
